import { Injectable } from '@angular/core';
import { UserGroupModel } from './model/usergroup.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class UserGroupService {

  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/common/usergroup/get', requestData);

  }

  /**
   * 
   * @param userGroup id
   * Calls the API to get a specified user group
   */
  getById(id: number): Observable<any> {
    return this.http.get(environment.baseUrl + '/common/usergroup/' + id);
  }

  /**
  * 
  * @param userGroup
  * Calls the update API to insert/update the record
  */
  update(userGroup: UserGroupModel): Observable<any> {
    if (userGroup.hasOwnProperty("id")) {
      return this.http.put(environment.baseUrl + '/common/usergroup', userGroup);
    } else {
      return this.http.post(environment.baseUrl + '/common/usergroup', userGroup);
    }
  }


  /**
 * 
 * @param userGroup
 * Calls the API to delete the record
 */
  delete(userGroup: UserGroupModel): Observable<any> {
    return this.http.delete(environment.baseUrl + '/common/usergroup/' + userGroup.id);
  }

  /**
* Get permissions for a particular application and user group
* @param app Application name (eps, pos, crm, oo, csms)
* @param userGroupId User group ID
*/
  getPermission(app: string, userGroupId: number): Observable<any> {
    return this.http.get(environment.baseUrl + `/common/usergroup/permission/app/${app}/group/${userGroupId}`);
  }

  /**
   * Get system functions for a particular application
   * @param app Application name (eps, pos, crm, oo, csms)
   */
  getSystemFunctions(app: string): Observable<any> {
    return this.http.post(environment.baseUrl + `/application-usergroup/${app}/get-system-functions`, {});
  }

  /**
   * Update permissions for a particular application and user group
   * @param app Application name (eps, pos, crm, oo, csms)
   * @param userGroupId User group ID
   * @param permissions Array of permission objects
   */
  updatePermissions(app: string, userGroupId: number, permissions: any[]): Observable<any> {
    const payload = {
      userGroupId: userGroupId,
      permissions: permissions
    };
    return this.http.post(environment.baseUrl + `/common/usergroup/permission/app/${app}/group/${userGroupId}`, payload);
  }

  /**
   * Get WFM data permissions for a user group and system function
   */
  getWfmDataPermissions(userGroupId: number, functionId: number): Observable<any> {
    return this.http.get(environment.baseUrl + `/common/usergroup/permission/wfm/data-permissions/group/${userGroupId}/function/${functionId}`);
  }

  /**
   * Save WFM data permissions for a user group and system function
   */
  saveWfmDataPermissions(userGroupId: number, functionId: number, permissions: any[]): Observable<any> {
    const payload = { permissions: permissions };
    return this.http.post(environment.baseUrl + `/common/usergroup/permission/wfm/data-permissions/group/${userGroupId}/function/${functionId}`, payload);
  }
}

